import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BaseButton } from '../components/base-button/Component.js';

var defaultColors = {"primary":"button__primary_2ols4","loader":"button__loader_2ols4","secondary":"button__secondary_2ols4","text":"button__text_2ols4","ghost":"button__ghost_2ols4","component":"button__component_2ols4","loading":"button__loading_2ols4","outlined":"button__outlined_2ols4","tertiary":"button__tertiary_2ols4","transparent":"button__transparent_2ols4","link":"button__link_2ols4"};
require('./default.desktop.css')

var styles = {"size-32":"button__size-32_10ah1","size-40":"button__size-40_10ah1","size-48":"button__size-48_10ah1","size-56":"button__size-56_10ah1","size-64":"button__size-64_10ah1","size-72":"button__size-72_10ah1"};
require('./desktop.css')

var invertedColors = {"primary":"button__primary_13qn6","loader":"button__loader_13qn6","secondary":"button__secondary_13qn6","text":"button__text_13qn6","ghost":"button__ghost_13qn6","component":"button__component_13qn6","loading":"button__loading_13qn6","outlined":"button__outlined_13qn6","tertiary":"button__tertiary_13qn6","transparent":"button__transparent_13qn6","link":"button__link_13qn6"};
require('./inverted.desktop.css')

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var ButtonDesktop = forwardRef(function (restProps, ref) { return (React.createElement(BaseButton, __assign({}, restProps, { ref: ref, styles: styles, colorStylesMap: colorStyles }))); });

export { ButtonDesktop };
